import { render, staticRenderFns } from "./LogoutRedirect.vue?vue&type=template&id=8603f6e6"
import script from "./LogoutRedirect.vue?vue&type=script&lang=js"
export * from "./LogoutRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports